import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { spacesClient } from '#pplx_generated/typespec/rest/spaces/client.js';
export const unpinUserSpace = async ({ spaceUuid, reason, }) => {
    const { data, error, response } = await spacesClient.DELETE('/rest/spaces/user-pins/{space_uuid}', reason, {
        params: { path: { space_uuid: spaceUuid } },
        timeoutMs: getQueryTimeoutMs(),
        numRetries: 0,
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to unpin user space',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=unpinUserSpace.js.map